import {BREAK_POINTS} from './settings';

(function ($) {
  $(document).ready(function () {
    $('.js-intv-slick').slick({
      appendDots : $('.js-intv-slick-ctrl'),
      appendArrows : $('.js-intv-slick-ctrl'),
      dots: true,
      prevArrow: '<button type="button" class="slick-prev"><i class="c-icon c-icon--arrow-prev"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="c-icon c-icon--arrow"></i></button>',
      fade: true
    });
    $('.js-intv-slick').slick('slickGoTo', slickNext);

    $('.slick-dots button').each(function(i) {
      $(this).text('0' + (i +1))
    })

    if($(window).width() < BREAK_POINTS.ltSP) {
      $('.js-mthd-sp-slick').slick({
        prevArrow: '<button type="button" class="slick-prev"><i class="c-icon c-icon--arrow-prev"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="c-icon c-icon--arrow"></i></button>',
        infinite: false
      })
    }

    $('.js-ov-sc-hint').on('scroll', function() {
      $(this).find('.js-sc-hint').remove();
    })
  });

})(jQuery);
